import { cloneElement, type ReactElement, type FC } from 'react'
import cx from 'classnames'
import { twMerge } from 'tailwind-merge'
import React from 'react'
import { type DefaultProps } from '../common'

export interface TagProps extends DefaultProps {
  /**
   * Tag component size
   */
  size?: 'small' | 'large'
  icon?: React.ReactNode
  state?: 'default' | 'pending' | 'error'
  disabled?: boolean
}

export const Tag: FC<TagProps> = ({
  // Custom component properties
  size = 'small',
  // Common default properties for each component
  className,
  id,
  testId,
  ariaLabel,
  children,
  icon,
  state = 'default',
  disabled = false,
}) => {
  // Component base class names. Can be overridden by className property.
  const baseClass = cx('w-fit rounded-full flex gap-1 items-center', {
    'typo-primary-xs-semibold py-3xs px-2xs bg-gray-100 text-olive-400': size === 'small',
    'typo-primary-sm-semibold py-3xs px-xs border border-border-dark text-text-meta': size === 'large',
    'bg-orange-400 border-none text-orange-80': state === 'pending',
    'bg-red-50 text-text-body-error border-none': state === 'error',
    'flex items-center bg-olive-50 text-text-disabled': disabled,
  })

  // Final class names
  const finalClasses = twMerge(baseClass, className)

  return (
    <div
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      aria-hidden="true"
    >
      {/* {icon ? <span className="size-3">{icon}</span> : null} */}
      {icon
        ? cloneElement(icon as React.ReactElement, {
            className: twMerge(
              cx({ 'size-3': size === 'small', 'size-4': size === 'large' }),
              (icon as ReactElement).props.className,
            ),
          })
        : null}

      {children}
    </div>
  )
}
